import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSearchParam } from "react-use";
import {
  DestinationTypeEnum,
  DestinationTypeMap,
} from "../../../enums/destination";
import useSelectedAccount from "../../../hooks/useSelectedAccount";
import { AllDestinations } from "../../../models";
import {
  useCreateDestinationMutation,
  useGetDestinationQuery,
  useTestDestinationMutation,
  useUpdateDestinationMutation,
} from "../../../redux/services/destinations";
import { initialValues, secretKeyMask } from "../utils/formValidationUtils";

export const useDestination = () => {
  const destinationId = useParams().id; // Edit

  const destinationType =
    useSearchParam("type") === DestinationTypeMap[DestinationTypeEnum.WORDPRESS]
      ? DestinationTypeEnum.WORDPRESS
      : DestinationTypeEnum.SHOPIFY; // find better way

  const { accountId } = useSelectedAccount();

  const { data: destination } = useGetDestinationQuery(
    {
      accountId,
      destinationId,
    },
    { skip: !accountId || !destinationId }
  );

  const [
    createDestination,
    {
      isLoading: isCreateLoading,
      isSuccess: isCreateSuccess,
      isError: isCreateError,
      error: createErrorMessage,
    },
  ] = useCreateDestinationMutation();

  const [
    updateDestination,
    {
      isLoading: isUpdateLoading,
      isSuccess: isUpdateSuccess,
      isError: isUpdateError,
      error: updateErrorMessage,
    },
  ] = useUpdateDestinationMutation();

  const [
    testDestination,
    {
      isLoading: isTestLoading,
      isError: isTestError,
      data: testSuccessData,
      error: testErrorMessage,
    },
  ] = useTestDestinationMutation();

  const [formValues, setFormValues] = useState<AllDestinations>();
  const [initialSnapshot, setInitialSnapshot] = useState<AllDestinations>();

  useEffect(() => {
    if (!destinationType) return;

    if (destination) {
      const secretKeyMasked = `${secretKeyMask}${destination.destination.secretKey}`;
      const values = {
        ...destination,
        destination: {
          ...destination.destination,
          secretKey: secretKeyMasked,
        },
      };
      setFormValues(values as AllDestinations);
    } else {
      setFormValues(initialValues[destinationType]);
    }
  }, [destination, destinationType]);

  useEffect(() => {
    if (formValues) {
      // for comparison to directly save or do test
      setInitialSnapshot(JSON.parse(JSON.stringify(formValues)));
    }
  }, [formValues]);

  return {
    destinationType,
    destinationId,
    destination,
    formValues,
    initialSnapshot,

    createDestination,
    isCreateLoading,
    isCreateSuccess,
    isCreateError,
    createErrorMessage,

    updateDestination,
    isUpdateLoading,
    isUpdateSuccess,
    isUpdateError,
    updateErrorMessage,

    testDestination,
    isTestLoading,
    isTestError,
    testSuccessData,
    testErrorMessage,
  };
};
